import React, { type FC, useEffect } from 'react';
import { SkeletonCompiled } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { asyncTeamPickerEditEntryPoint } from '../entrypoint.tsx';
import type { Props as TeamPickerProps } from './ui/edit-mode/index.tsx';

const EMPTY_OBJECT = {} as const;

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyTeamPickerEdit = lazy<FC<TeamPickerProps>>(
	() =>
		import(/* webpackChunkName: "async-jira-issue-atlassian-team-picker-edit" */ './ui/edit-mode'),
);

export const AsyncTeamPickerEdit = (props: TeamPickerProps) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		asyncTeamPickerEditEntryPoint,
		// use stable object reference to avoid re-renders
		EMPTY_OBJECT,
	);

	// eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="async-jira-issue-atlassian-team-picker-edit"
			packageName="jira-issue-field-team"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={props}
			fallback={<SkeletonCompiled width="350px" height="40px" />}
			errorFallback="unmount"
		/>
	);
};
